import React from 'react';
import { TopItemsList } from '@/components/visuals';
import type { TopItem } from '@/components/visuals';

export interface FocusChartWithTableProps {
  /** Chart content (e.g. from renderChart) */
  chart: React.ReactNode;
  /** Rows for the table below the chart */
  items: TopItem[];
  /** Column header for the value (default: "Value") */
  valueLabel?: string;
  /** Custom value formatter */
  valueFormat?: (v: number) => string;
}

/**
 * Focus-mode layout: chart above, TopItemsList below.
 * Keeps renderFocusChart as thin orchestration (derive items, pass here).
 */
export const FocusChartWithTable: React.FC<FocusChartWithTableProps> = ({
  chart,
  items,
  valueLabel = 'Value',
  valueFormat,
}) => (
  <>
    {chart}
    <TopItemsList items={items} valueLabel={valueLabel} valueFormat={valueFormat} />
  </>
);
